import {
  InputAddBranchQuoteSupport,
  BranchQuoteSupportStatus,
  BranchQuoteSupportItemType,
  SupportQuoteItemLinkDetail,
  AddConversationAttachment,
  InputFirstConversationEntry
} from '../../api/dealer-api-interface-franchisee';
import { newGuid } from '../../../webmodule-common/other/api/guid';
import { isEmptyOrSpace } from '../../../webmodule-common/other/ui/string-helper-functions';

export interface BuildSupportTicketCreateInputArgs {
  quoteId: string;
  supportType: BranchQuoteSupportItemType;
  status?: BranchQuoteSupportStatus.Draft | BranchQuoteSupportStatus.New;
  subject: string;
  text: string;
  draft: boolean;
  attachments: AddConversationAttachment[]; // concrete type
  quoteItemLinks: Record<string, SupportQuoteItemLinkDetail>;
  masterDocumentConversationId?: string | null;
  /** Optional single master document attachment (EngineeredToOrder only). Only one master document entry ever. */
  masterDocumentFilename?: string | null;
  // Optional pre-generated ids (allows caller to keep existing ids backward compatible)
  branchQuoteSupportId?: string;
  conversationEntryId?: string;
}

export function buildSupportTicketCreateInput(args: BuildSupportTicketCreateInputArgs): InputAddBranchQuoteSupport {
  const branchQuoteSupportId = args.branchQuoteSupportId ?? newGuid();
  const conversationEntryId = args.conversationEntryId ?? newGuid();
  // Correctly derive status using the actual enum (previous version hard‑coded numeric values that could drift).
  const status: BranchQuoteSupportStatus = args.draft ? BranchQuoteSupportStatus.Draft : BranchQuoteSupportStatus.New;
  // Engineered To Order: create an empty master document entry on ticket creation (rules require early presence)
  const masterDocEntry: InputFirstConversationEntry | null =
    args.supportType === BranchQuoteSupportItemType.EngineeredToOrder || args.masterDocumentConversationId
      ? {
          id: args.masterDocumentConversationId ?? newGuid(),
          attachments: !isEmptyOrSpace(args.masterDocumentFilename)
            ? [{ filename: args.masterDocumentFilename ?? '' }]
            : [],
          text: 'MASTERDOCUMENT',
          users: [],
          draft: false
        }
      : null;

  return {
    quoteItemLink: args.quoteItemLinks,
    id: branchQuoteSupportId,
    masterDocumentConversationEntry: masterDocEntry,
    conversationId: branchQuoteSupportId,
    branchQuoteId: args.quoteId,
    status,
    subject: args.subject,
    type: args.supportType,
    conversationEntry: {
      id: conversationEntryId,
      attachments: args.attachments ?? [],
      text: args.text,
      users: [],
      draft: !!args.draft
    }
  };
}

// ticket-created DOM event removed; external listeners should subscribe to service snapshots (delta.reason==='create').
